import { useMutation, useQueryClient } from 'react-query';
import { ITcoDeviceSelection } from 'types';
import { queryKeys, tcoDeviceSelectionsRequest } from 'utils';

export const useUpdateTcoDeviceSelection = (estimateId: string) => {
  const queryClient = useQueryClient();
  const deviceSelectionsKey = queryKeys({ estimateId }).filter
    .tcoDeviceSelections;

  const {
    mutate: updateTcoDeviceSelection,
    isLoading: updateTcoDeviceSelectionLoading,
    isSuccess: updateTcoDeviceSelectionSuccess,
    isError: updateTcoDeviceSelectionError,
  } = useMutation(
    (tcoDeviceSelection: ITcoDeviceSelection) =>
      tcoDeviceSelectionsRequest({
        endpoint: `tco-device-selections/${tcoDeviceSelection.id}`,
        method: 'PUT',
        data: tcoDeviceSelection,
      }),
    {
      onMutate: async (updatedDeviceSelection: ITcoDeviceSelection) => {
        await queryClient.cancelQueries(deviceSelectionsKey);

        const prevDeviceSelections =
          queryClient.getQueryData<ITcoDeviceSelection[]>(
            deviceSelectionsKey
          ) || [];

        const newDeviceSelections = [
          ...prevDeviceSelections.filter(
            (s) => s.id !== updatedDeviceSelection.id
          ),
          updatedDeviceSelection,
        ];

        queryClient.setQueryData(deviceSelectionsKey, newDeviceSelections);

        return { prevDeviceSelections };
      },
      onError: async (err, _, context) => {
        console.log(err);
        await queryClient.cancelQueries(deviceSelectionsKey);
        queryClient.setQueryData(
          deviceSelectionsKey,
          context?.prevDeviceSelections
        );
      },
      onSettled: () => {
        queryClient.invalidateQueries(deviceSelectionsKey);
      },
    }
  );

  return {
    updateTcoDeviceSelection,
    updateTcoDeviceSelectionLoading,
    updateTcoDeviceSelectionSuccess,
    updateTcoDeviceSelectionError,
  };
};
